import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";

function useEmployeeList(params, skip = false) {
  return useSWR(
    !skip
      ? {
          path: `/api/v1/users`,
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useEmployeeList;
